import { DateTime } from "luxon";
import { useCompanyTimeZone } from "./useCompanyTimeZone";
import { useCurrentTime } from "./useCurrentTime";

export const useCurrentCompanyTime = () => {
  const now = useCurrentTime();
  const { timeZone } = useCompanyTimeZone();

  return DateTime.fromJSDate(now).setZone(timeZone);
};
